import { useNotificationsContext } from "common/context/NotificationsProvider"
import { nanoid } from "nanoid"
import { ProgressSpinner } from "primereact/progressspinner"
import { useEffect, useMemo } from "react"
import { useTranslation } from "react-i18next"
import "../style.scss"
import NotificationsByMonth from "./NotificationsByMonth"
import NotificationsDatesLine from "./NotificationsDatesLine"
import NotificationsGetMoreButton from "./NotificationsGetMoreButton"
import NotificationsNoData from "./NotificationsNoData"
import { mapNotifications } from "./constants"

const NotificationsList = () => {
  const { t } = useTranslation()
  // @ts-expect-error TS(2339): Property 'allNotifications' does not exist on type...
  const { allNotifications, fetchPageNotifications, allNotificationsLoading } =
    useNotificationsContext()

  const notifications = useMemo(
    () => mapNotifications(allNotifications?.list, t),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [allNotifications?.list]
  )

  useEffect(() => {
    if (allNotifications.notUpdated) fetchPageNotifications()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allNotifications.notUpdated])

  const notificationsListContent = (
    <>
      <div className='notifications-list-container d-flex flex-column'>
        <NotificationsDatesLine />
        {/* @ts-expect-error TS(2339): Property 'map' does not exist on type 'string'. */}
        {notifications?.map((monthNotifications: $TSMigrationFixMe) => (
          <NotificationsByMonth
            key={nanoid()}
            data={monthNotifications}
          />
        ))}
      </div>
      {allNotificationsLoading ? (
        <div className='h-100 d-flex align-items-center'>
          <ProgressSpinner />
        </div>
      ) : (
        <NotificationsGetMoreButton />
      )}
    </>
  )

  return (
    <div className='notifications-list d-flex flex-column w-75'>
      {allNotifications.totalCount > 0 ? (
        notificationsListContent
      ) : (
        <NotificationsNoData />
      )}
    </div>
  )
}

export default NotificationsList
